






































import {
  defineComponent,
  ref,
  inject,
  computed,
  onMounted
} from '@vue/composition-api'
import Loader from '@/contexts/frontend/Loader.vue'
import { ClientAdminApiKey, Login } from '@/rest/client-admin-api'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faPencilAlt,
  faTrashAlt,
  faSearch,
  faTimes
} from '@fortawesome/free-solid-svg-icons'

library.add(faPencilAlt, faTrashAlt, faSearch, faTimes)

export default defineComponent({
  components: {
    loader: Loader
  },

  setup() {
    const logins = ref([] as Array<Login>)
    const next = ref(null)
    const loading = ref(true)
    const clientAdminApi = inject(ClientAdminApiKey)

    onMounted(async () => {
      const response = await clientAdminApi?.ListLogins()
      if (response?._tag == 'success') {
        logins.value = response.data.users
        next.value = response.data.next
      } else {
        //eslint-disable-next-line
        console.error({ response })
      }
      loading.value = false
    })

    const loginsFound = computed(() => logins.value.length > 0)

    const more = async () => {
      const response = await clientAdminApi?.ListLogins(encodeURI(next.value))
      if (response?._tag == 'success') {
        logins.value = [...logins.value, ...response.data.users]
        next.value = response.data.next
      }
    }

    return {
      logins,
      loading,
      loginsFound,
      next,
      more
    }
  }
})
